import { forwardRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@etframework/ui.components";
import { ArrayUpdateInput } from "./Inputs/ArrayUpdateInput";
import { SourceUpdateInput } from "./Inputs/SourceUpdateInput";
import { DateUpdateInput } from "./Inputs/DateUpdateInput";
import { BooleanUpdateInput } from "./Inputs/BooleanUpdateInput";
import { CustomUpdateInput } from "./Inputs/CustomUpdateInput";
import { TextboxUpdateInput } from "./Inputs/TextboxUpdateInput";

export const PropertyRow = ({
  field,
  label,
  children,
  content,
  footer,
  onRemove,
  settings,
  showRemoveButtonOnTop,
}) => {
  const { t } = useTranslation(["BulkUpdateTasksModal", "Shared"], {
    useSuspense: false,
  });

  const removeButton = (
    <IconButton
      className={"remove-button"}
      iconCss="fa-regular fs-14 et-dark-gray fa-circle-minus et-darkest-gray"
      onClick={() => {
        onRemove?.(field);
      }}
      isTerciary
    />
  );

  return (
    <div className="property-editor-row">
      <div className="px-3 py-3">
        {label && (
          <div className="mb-1 d-flex justify-content-between align-items-center">
            {settings.noTranslations
              ? settings.headerText
              : t(`Columns.${label ?? field}`)}
            {showRemoveButtonOnTop && removeButton}
          </div>
        )}
        <div className="d-flex gap-3 align-items-center justify-content-between">
          {children || content}
          {!showRemoveButtonOnTop && removeButton}
        </div>
      </div>
      {footer}
    </div>
  );
};

export const PropertyUpdateRowInput = forwardRef(
  ({ id, field, onChange, settings, ...rest }, ref) => {
    const _onChange = (e) => {
      e.field = field;
      onChange?.(e);
    };

    const InputComponent = useMemo(() => {
      const map = {
        source_array: ArrayUpdateInput,
        source: SourceUpdateInput,
        date: DateUpdateInput,
        boolean: BooleanUpdateInput,
        custom: CustomUpdateInput,
        default: TextboxUpdateInput,
      };

      let componentType = settings?.type;
      if (componentType && settings?.propertyType)
        componentType = componentType.concat("_", settings.propertyType);

      return map[componentType] ?? map.default;
    }, []);

    return (
      <InputComponent
        {...rest}
        ref={ref}
        field={field}
        settings={settings}
        change={_onChange}
        id={id}
      />
    );
  }
);
